import { ContentPreviewer } from '@shared/components';
import { useCallback, useEffect, useState } from 'react';

import { useParseContentForItemSetQuestionCreation } from '../../hooks';

function useParseItemSetContent(content: string, questionGroupId: string, taskId: string) {
  const { parseItemSetQuestionContent } = useParseContentForItemSetQuestionCreation({
    questionGroupId,
    taskId,
  });
  const [parsedContent, setParsedContent] = useState('');

  const handleParsedImage = useCallback(async () => {
    if (!content) return;

    const parsedContent = await parseItemSetQuestionContent(content);

    setParsedContent(parsedContent);
  }, [content, parseItemSetQuestionContent]);

  useEffect(() => {
    handleParsedImage();
  }, [handleParsedImage]);

  return {
    content: parsedContent,
  };
}

interface ItemSetContentPreviewerProps {
  content: string;
  itemSetId: string;
  taskId: string;
}

export default function ItemSetContentPreviewer(props: Readonly<ItemSetContentPreviewerProps>) {
  const { content, itemSetId: questionGroupId, taskId } = props;
  const { content: parsedContent } = useParseItemSetContent(content, questionGroupId, taskId);

  return <ContentPreviewer content={parsedContent} />;
}
